var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-chart',{attrs:{"title":_vm.title,"tickets":_vm.tickets,"loaded":_vm.loaded,"status-list":_vm.statusList,"search-key":_vm.searchKey,"equip-label":_vm.equipLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }